import { TFunction } from "i18next";
import * as Yup from "yup";

import { email_validation_regex, MIN_PASSWORD_LENGTH } from "./login";

export const createUserSchema = (t: TFunction) =>
    Yup.object({
        email: Yup.string()
            .email(t("login.invalid_format"))
            .matches(email_validation_regex, t("login.invalid_format")),
        password: Yup.string().min(
            MIN_PASSWORD_LENGTH,
            t("login.password_length", { length: MIN_PASSWORD_LENGTH }),
        ),
        confirmPassword: Yup.string().when("password", {
            is: (password: string) => !!password,
            then: (schema) =>
                schema.oneOf(
                    [Yup.ref("password")],
                    t("user.password_mismatch"),
                ),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
